module.exports = __webpack_public_path__ + "static/u1-89bf68d7d1bdf954d9e1a0c093092eea.png";